module.exports = __webpack_public_path__ + "img/index1.6b366b71.png";